<div class="new-issue-form-container">
  <form [formGroup]="existingIssueForm">
    <!-- SECTION 1: IssueID + Description -->
    <div class="actionColumn tab-header pr-10">
      <div class="align-items-center" style="min-width: 433px !important">
        <h3 class="mb-0 mr-10 text-nowrap">IssueID</h3>
        <select class="form-select mt-5" formControlName="issueId" (change)="onIssueChange($event)">
          <option value="" disabled>Select Issue ID</option>
          @for (issue of issueIdResponse$(); track issue.issueID) {
            <option [value]="issue.issueID">{{ issue.issueID }} - {{ issue.keyWord }}</option>
          }
        </select>
      </div>

      @if (existingIssueForm.get('issueId')?.value && isSaveVisible) {
        <button type="button" class="btn btn-primary mr-5" (click)="saveRecord()">
          Save Adjustment
        </button>
      }
    </div>

    @if (existingIssueForm.get('issueId')?.value) {
      <div class="formsContainer">
        <div class="row m-0">
          <div class="col-12 mb-10 p-0">
            <h3 class="mb-0">Description</h3>
            <textarea
              id="description"
              class="form-control mt-5"
              formControlName="description"
              rows="4"
              placeholder="Enter Issue Description"
            ></textarea>
          </div>
        </div>

        <!-- SECTION 2: Issue Details -->
        <div class="container-fluid p-0 accountingFilters">
          <!-- Row 1 -->
          <div class="row m-0 issueRow">
            <!-- Entity Code -->
            <div class="issueCol">
              <h3 class="mb-0">Entity Code <span class="text-danger">*</span></h3>
              <select
                class="form-select mt-5 textOverlapDropdown"
                formControlName="entityCode"
                [class.is-invalid]="
                  existingIssueForm.get('entityCode')?.invalid &&
                  existingIssueForm.get('entityCode')?.touched
                "
              >
                <option value="" disabled>Select</option>
                @for (entity of entitiesResponse$(); track entity.entityCode) {
                  <option [value]="entity.entityCode">
                    {{ entity.entityCode }} | {{ entity.entity }}
                  </option>
                }
              </select>
              @if (
                existingIssueForm.get('entityCode')?.invalid &&
                existingIssueForm.get('entityCode')?.touched
              ) {
                <h2 class="error-MSG m-0">Entity Code is required.</h2>
              }
            </div>
            <!-- Issue Year -->
            <div class="issueCol">
              <h3 class="mb-0">Issue Year <span class="text-danger">*</span></h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="issueYear"
                inputmode="numeric"
                maxlength="4"
                placeholder="Enter Issue Year"
                [class.is-invalid]="
                  existingIssueForm.get('issueYear')?.invalid &&
                  existingIssueForm.get('issueYear')?.touched
                "
              />
              @if (
                existingIssueForm.get('issueYear')?.hasError('required') &&
                existingIssueForm.get('issueYear')?.touched
              ) {
                <h2 class="error-MSG m-0">Issue Year is required.</h2>
              }
              @if (
                !existingIssueForm.get('issueYear')?.hasError('required') &&
                existingIssueForm.get('issueYear')?.hasError('pattern') &&
                existingIssueForm.get('issueYear')?.touched
              ) {
                <h2 class="error-MSG m-0">Invalid year. It must be exactly 4 digits.</h2>
              }
            </div>
            <!-- E&P Adj Required -->
            <div class="issueCol">
              <h3 class="mb-0">E&P Adj Required</h3>
              <select class="form-select mt-5" formControlName="epAdjRequired">
                <option value="" disabled>Select</option>
                @for (option of yesNoOptions; track option.value) {
                  <option [value]="option.value">
                    {{ option.label }}
                  </option>
                }
              </select>
            </div>
          </div>

          <!-- Row 2 -->
          <div class="row m-0 issueRow mt-15">
            <div class="issueCol">
              <h3 class="mb-0 mr-10">Contact</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="contact"
                placeholder="Enter Contact"
              />
            </div>
            <div class="issueCol">
              <h3 class="mb-0">Approver</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="approver"
                placeholder="Enter Approver"
              />
            </div>
            <div class="issueCol">
              <h3 class="mb-0">TBBS Adj Required</h3>
              <select class="form-select mt-5" formControlName="tbbsAdjRequired">
                <option value="" disabled>Select</option>
                @for (option of yesNoOptions; track option.value) {
                  <option [value]="option.value">
                    {{ option.label }}
                  </option>
                }
              </select>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="row m-0 issueRow mt-15">
            <div class="issueCol">
              <h3 class="mb-0">CFC/NC-902</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="cfcNc902"
                placeholder="Enter CFC/NC-902"
              />
            </div>
            <div class="issueCol">
              <h3 class="mb-0">Date Reviewed</h3>
              <input type="date" class="calender mt-5" formControlName="dateReviewed" />
            </div>
            <div class="issueCol">
              <h3 class="mb-0">Date Corptax Adj</h3>
              <input type="date" class="calender mt-5" formControlName="dateCorptaxAdj" />
            </div>
          </div>

          <!-- Adj. Descrip. -->
          <div class="row m-0 mt-15">
            <div class="col-12 p-0">
              <h3 class="mb-0">Adj. Descrip.</h3>
              <textarea
                class="form-control mt-5"
                formControlName="adjDescrip"
                rows="5"
                placeholder="Enter Adjustment Description"
              >
              </textarea>
            </div>
          </div>
        </div>

        <!-- SECTION 3: Tabs + Grids -->
        <div class="tab-header tab-header-compact mt-2">
          <div class="tab-columns">
            <h2
              class="mb-0 tab-item"
              [class.active]="activeTab === 'prior2018'"
              (click)="selectTab('prior2018')"
            >
              <span>Prior 2018</span>
            </h2>
            <h2
              class="mb-0 tab-item"
              [class.active]="activeTab === 'after2017'"
              (click)="selectTab('after2017')"
            >
              <span>After 2017</span>
            </h2>
            <h2
              class="mb-0 tab-item"
              [class.active]="activeTab === 'auditPrior'"
              (click)="selectTab('auditPrior')"
            >
              <span>Audit Updates - Prior 2018</span>
            </h2>
            <h2
              class="mb-0 tab-item"
              [class.active]="activeTab === 'auditAfter'"
              (click)="selectTab('auditAfter')"
            >
              <span>Audit Updates - After 2017</span>
            </h2>
          </div>
          <div class="d-flex align-items-center gap-1">
            <input type="checkbox" formControlName="deduction199" />
            <h3 class="mb-0">199 Deduction</h3>
          </div>
        </div>

        @if (activeTab === 'prior2018') {
          <app-issue-prior-2018
            [records]="prior2018Records"
            [mode]="action === 'edit' ? 'allIssues' : 'existing'"
            [action]="'edit'"
            [isExistingHeaderVisible]="true"
          >
          </app-issue-prior-2018>
        }
        @if (activeTab === 'auditPrior') {
          <app-issue-prior-2018
            [records]="auditPrior2018Records"
            [mode]="action === 'edit' ? 'allIssues' : 'existing'"
            [action]="'edit'"
            [isExistingHeaderVisible]="true"
          >
          </app-issue-prior-2018>
        }

        @if (activeTab === 'after2017') {
          <app-issue-after-2017
            [records]="after2017Records"
            [screen]="action === 'edit' ? 'allIssues' : 'existing'"
            [action]="'edit'"
            [isExistingHeaderVisible]="true"
          >
          </app-issue-after-2017>
        }

        @if (activeTab === 'auditAfter') {
          <app-issue-after-2017
            [records]="auditAfter2017Records"
            [screen]="action === 'edit' ? 'allIssues' : 'existing'"
            [action]="'edit'"
            [isExistingHeaderVisible]="true"
          >
          </app-issue-after-2017>
        }

        <!-- SECTION 4: Filing Details -->
        <div class="container-fluid p-0 mt-10 accountingFilters">
          <!-- Row 1 -->
          <div class="row m-0 issueRow">
            <div class="issueCol">
              <h3 class="mb-0">AR Filing ID <span class="text-danger">*</span></h3>
              <select
                class="form-select mt-5"
                formControlName="arFilingId"
                (click)="onArFilingDropdownClick()"
                [class.is-invalid]="
                  (existingIssueForm.hasError('filingRequired') && existingIssueForm.touched) ||
                  (existingIssueForm.hasError('onlyOneAllowed') && existingIssueForm.touched)
                "
              >
                <option value="">
                  {{ arFilingPlaceholder }}
                </option>
                @for (amended of amendedDetails$(); track amended.amendedID) {
                  <option [value]="amended.amendedID">
                    {{ amended.amendedID }}
                  </option>
                }
              </select>
            </div>

            <div class="issueCol">
              <h3 class="mb-0">AR Issue ID</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="arIssueId"
                placeholder="Enter AR Issue ID"
              />
            </div>

            <div class="issueCol">
              <h3 class="mb-0">IRS Issue ID</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="irsIssueID"
                placeholder="Enter IRS Issue ID"
              />
            </div>
          </div>

          <!-- Row 2 -->
          <div class="row m-0 issueRow mt-15">
            <!-- SAA -->

            <div class="issueCol">
              <h3 class="mb-0">SAA <span class="text-danger">*</span></h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="saa"
                placeholder="Enter SAA"
                [class.is-invalid]="
                  (existingIssueForm.hasError('filingRequired') && existingIssueForm.touched) ||
                  (existingIssueForm.hasError('onlyOneAllowed') && existingIssueForm.touched)
                "
              />
              @if (existingIssueForm.hasError('filingRequired') && existingIssueForm.touched) {
                <h2 class="error-MSG m-0">Select either SAA or AR Filing ID.</h2>
              }
              @if (existingIssueForm.hasError('onlyOneAllowed') && existingIssueForm.touched) {
                <h2 class="error-MSG m-0">Only one of SAA or AR Filing ID can be selected.</h2>
              }
            </div>
            <!-- Submission -->
            <div class="issueCol">
              <h3 class="mb-0">Submission</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="submission"
                placeholder="Enter Submission"
              />
            </div>
            <!-- SP Doc Link -->
            <div class="issueCol">
              <h3 class="mb-0">SP Doc Link</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="spDocLink"
                placeholder="Enter SP Doc Link"
              />
            </div>
          </div>

          <!-- Row 3 -->
          <div class="row m-0 issueRow mt-15">
            <div class="issueCol">
              <h3 class="mb-0">NPA</h3>
              <input
                type="text"
                class="form-control mt-5"
                formControlName="npa"
                placeholder="Enter NPA"
              />
            </div>
            <div class="issueCol">
              <h3 class="mb-0">NPA ties to AR/SAA</h3>
              <select class="form-select mt-5" formControlName="npaTiesToArSaa">
                <option value="" disabled>Select</option>
                @for (option of yesNoOptions; track option.value) {
                  <option [value]="option.value">
                    {{ option.label }}
                  </option>
                }
              </select>
            </div>
            <div class="issueCol">
              <h3 class="mb-0">Issue Status</h3>
              <select class="form-select mt-5" formControlName="issueStatus">
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-Flex mt-15 mb-15 justify-content-between dates">
          <div class="d-Flex pl-5 mt-15">
            <h3 class="m-0">Created On:</h3>
            <p class="ml-5 mb-0">{{ createdDate }}</p>
          </div>

          <div class="d-Flex pr-5 mt-15">
            <h3 class="m-0">Modified On:</h3>
            <p class="ml-5 mb-0">{{ modifiedDate }}</p>
          </div>
        </div>
      </div>
    }
  </form>
</div>
